export enum BookingState {
  Created = "created",
  Reserved = "reserved",
  Started = "started",
  Stopped = "stopped",
  Paid = "paid",
  Verified = "verified",
  Deleted = "deleted",
  Expired = "expired",
  RecentlyPaid = "recently_paid",
}
